<div [class.pt-4]="!props.readonly">
  @for (exam of examGroups$ | async; track exam) {
    <p-card [dt]="props.dt?.components?.card">
      <ng-template #title>
        @if (exam.level) {
          {{ exam.level | staticData: StaticDataType.LanguageModules | async }}
        }

        @if (exam.institution) {
          {{ exam.institution | staticData: StaticDataType.ExamInstitutions | async }}
        }
      </ng-template>

      <new-ui-formly-certified-education-exams-entry
        [dt]="props.dt"
        [disabled]="props.disabled"
        [readonly]="props.readonly"
        [candidateId]="formState?.candidateId"
        [organizationId]="formState?.organizationId"
        [examGroup]="exam"
        [form]="form"
        [showDocumentCompletion]="props.showDocumentCompletion"
      />
    </p-card>
  }
</div>
